// extracted by css-extract-rspack-plugin
export default {"ChipLabel":"BfuiA","ChipIconWrapper":"c1mXw","ChipInput":"kglJY"};